<div class="media people-card">
  <ng-container *ngIf="photoUrl$ | async as src;else letters">
    <a *ngIf="!enableProfileCardView;else profileCardViewPhoto" [attr.href]="getDelveUrl(person)" (click)="whenPersonClicked($event)" class="colleague-image-clickable-link">
      <div class="rounded-circle mr-3 mt-1" [ngStyle]="{'background-image': 'url(' + src + ')'}" [ngClass]="size" title="{{person.displayName}}"></div>
      <span class="sr-only">{{person.displayName}}</span>
    </a>
    <ng-template #profileCardViewPhoto>
      <a [attr.target]="newtab ? '_blank' : '_self'" class="action clickable" (click)="whenPersonClicked($event, true)" (keyup.enter)="whenPersonClicked($event, true)" class="ccolleague-image-clickable-link">
        <div class="rounded-circle mr-3 mt-1" [ngStyle]="{'background-image': 'url(' + src + ')'}" [ngClass]="size" title="{{person.displayName}}"></div>
        <span class="sr-only">{{person.displayName}}</span>
      </a>
    </ng-template>
  </ng-container>
  <ng-template #letters>
    <a *ngIf="!enableProfileCardView;else profileCardViewLetters"
       [attr.href]="getDelveUrl(person)"
       class="letters accent-2-bg-color rounded-circle position-relative d-inline-block align-middle mr-3 colleague-letter-clickable-link"
       [ngClass]="size"
       title="{{person.displayName}}"
       (click)="whenPersonClicked($event)">
      <h3 class="mb-0 letters-text">{{ getPreferredNameLetters(person) }}</h3>
    </a>
    <ng-template #profileCardViewLetters>
      <a [attr.target]="newtab ? '_blank' : '_self'"
         class="action letters accent-2-bg-color rounded-circle position-relative d-inline-block align-middle mr-3 clickable colleague-letter-clickable-link"
         [ngClass]="size" title="{{person.displayName}}"
         (keyup.enter)="whenPersonClicked($event, true)"
         (click)="whenPersonClicked($event, true)">
        <h3 class="mb-0 letters-text">{{ getPreferredNameLetters(person) }}</h3>
      </a>
    </ng-template>
  </ng-template>

  <div class="media-body">
    <div class="name extra-bold">
      <a *ngIf="!enableProfileCardView;else profileCardView" [attr.href]="getDelveUrl(person)" (click)="whenPersonClicked($event)" class="colleague-name-clickable-link">{{person.displayName}}</a>
      <ng-template #profileCardView>
        <a [attr.target]="newtab ? '_blank' : '_self'" class="action clickable colleague-name-clickable-link" (click)="whenPersonClicked($event, true)" (keyup.enter)="whenPersonClicked($event, true)">{{person.displayName}}</a>
      </ng-template>
    </div>

    <div class="description mt-1">
      <span class="text-muted">{{person.jobTitle}}</span>
    </div>

    <div *ngIf="expanded">
      <!-- optionally show department -->
      <div class="description mt-1" *ngIf="person.department && showDepartment">
        <span class="ms-Icon ms-Icon--Group"
              i18n-title="colleague department@@colleague-department"
              title="Department: {{person.department}}"></span>
        <span class="ml-3">{{person.department}}</span>
      </div>

      <!-- optionally show location -->
      <div class="description mt-1" *ngIf="person.officeLocation && showLocation">
        <span class="ms-Icon ms-Icon--POI"
              i18n-title="colleague officeLocation@@colleague-officeLocation"
              title="Office location: {{person.officeLocation}}"></span>
        <span class="ml-3">{{person.officeLocation}}</span>
      </div>

      <div class="description mt-1" *ngIf="person.mobilePhone">
        <span class="ms-Icon ms-Icon--Phone"
              i18n-title="colleague mobile@@colleague-mobile"
              title="Mobile: {{person.mobilePhone}}"></span>
        <span class="ml-3">
          <a href="tel:{{person.mobilePhone}}">{{person.mobilePhone}}</a>
          <ng-template [cdkPortalOutlet]="mobilePhonePortal"></ng-template>
        </span>
      </div>

      <!-- optionally show office phone -->
      <div class="description mt-1" *ngIf="person.businessPhones && person.businessPhones.length > 0 && showOfficePhone">
        <span class="ms-Icon ms-Icon--Phone"
              i18n-title="colleague workPhone@@colleague-work-phone"
              title="Work phone: {{person.businessPhones[0]}}"></span>
        <span class="ml-3">
          <a href="tel:{{person.businessPhones[0]}}">{{person.businessPhones[0]}}</a>
        </span>
      </div>

      <div class="description mt-1" *ngIf="person.mail">
        <span class="ms-Icon ms-Icon--Mail"
              i18n-title="colleague email@@colleague-email"
              title="Email: {{person.mail}}"></span>
        <span class="ml-3"><a href="mailto:{{person.mail}}">{{person.mail}}</a></span>
      </div>

      <div class="description mt-1" *ngIf="person.mail">
        <span class="ms-Icon ms-Icon--Chat"
              i18n-title="colleague chat@@colleague-chat"
              title="Start chat"></span>
        <span class="ml-3">
          <a [attr.href]="('https://teams.microsoft.com/l/chat/0/0?users=' + person.mail) | safe: 'url'"
             *ngIf="useTeamsChat">
            <span i18n="colleague chat@@colleague-chat">Start chat</span>
          </a>
          <a [attr.href]="('sip:' + person.mail) | safe: 'url'" *ngIf="!useTeamsChat">
            <span i18n="colleague chat@@colleague-chat">Start chat</span>
          </a>
        </span>
      </div>
      <div class="description mt-1" *ngIf="showOrgChart && !isExternalUser(person) && person.id">
        <span class="ms-Icon ms-Icon--Org"
              i18n-title="colleague-org-chart@@colleague-org-chart"
              title="Organizational chart"></span>
        <span class="ml-3">
          <a [attr.href]="('https://teams.microsoft.com/_#/people.organization/8:orgid:' + person.id + '?ctx=chat') | safe: 'url'">
            <span i18n="colleague chat@@colleague-org-chart">Organizational chart</span>
          </a>
        </span>
      </div>
    </div>

  </div>
</div>
